import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from '../../../environments/environment';
import { ShareDataServiceService } from '../../services/share-data-service.service';
import { Tender } from 'src/app/models/Tender.class';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.css'],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'translateX(100%)', opacity: 0}),
          animate('500ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1}),
          animate('500ms', style({transform: 'translateX(100%)', opacity: 0}))
        ])
      ]
    ),
    trigger(
      'leaveAnimation', [
        transition(':enter', [
          style({transform: 'translateX(100%)', opacity: 0, left:1}),
          animate('500ms', style({transform: 'translateX(0)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)', opacity: 1, left:0}),
          animate('500ms', style({transform: 'translateX(100%)', opacity: 0}))
        ])
      ]
    )
  ]
})
export class QuestionsComponent implements OnInit {

  getFromNavigaionState(key:string):any{
    const nav = this.router.getCurrentNavigation() || (this.router as any).lastSuccessfulNavigation;
    if(!nav || !nav.extras || !nav.extras.state || !nav.extras.state[key])
      return null;
    else
      return nav.extras.state[key];
  }

  constructor(private http: HttpClient,private route:ActivatedRoute, private router:Router, private fb:FormBuilder,private recaptchaV3Service: ReCaptchaV3Service,private shareDataService:ShareDataServiceService, private location: Location) {
  }

  @Input() tender:Tender = new Tender();
  @Output() onClose:EventEmitter<any> = new EventEmitter<any>();

  qForm:FormGroup = new FormGroup({
    QuesionnaireId:new FormControl(0),
    TenderId: new FormControl(0),
    HasRegistration:new FormControl('',Validators.required),
    ContactName: new FormControl('',[Validators.required,Validators.pattern("^([a-zA-Z0-9א-ת \"'/\\-_\\)\\(:])*$")]),
    ContactDetails: new FormControl('',[Validators.required,Validators.pattern("^([0-9א-תa-zA-Z \"_'\\\@\?!\.\(\)\:\,\/\\-\r\n])*$")]),
    ContactPhone1: new FormControl('',[Validators.required,Validators.pattern("^0\\d{1,2}-?\\d{7}$")]),
    ContactPhone2: new FormControl('',[Validators.pattern("^0\\d{1,2}-?\\d{7}$")]),
    ContactEmail: new FormControl('',[Validators.required,Validators.email]),
    ContactFax: new FormControl('',[Validators.pattern("^0\\d{1,2}-?\\d{7}$")]),
    CaptchaToken: new FormControl(''),
    Questions: this.fb.array([])
  });
  qsList = (this.qForm.controls.Questions as FormArray).controls;

  ngOnInit(): void {
    if (!this.tender.TenderId) {
      const stateTender = this.getFromNavigaionState('tender');
      if (stateTender) {
        this.tender = stateTender;
        this.onLoadTender();
      }
      else {
        if (!this.route.snapshot || !this.route.snapshot.params || !this.route.snapshot.params['id']) return;
        const id: string = this.route.snapshot.params['id'];
        this.shareDataService.get({ url: environment.serviceUrl + '/api/tenders/' + id, method: 'get' }, 'tender_' + id)
        .then((res:any)=> {
          this.tender = res;
          this.onLoadTender();
        },err=>{
          console.log(err);
        });
      }
    }
    else {
      this.onLoadTender();
    }   
  }

  onLoadTender():void{
    this.qForm.controls.TenderId.setValue(this.tender.TenderId);
    this.qForm.controls.HasRegistration.valueChanges.subscribe(val=>{
      console.log(val);
      console.log(this.qForm.controls.HasRegistration.value);
    });
    this.addQuestion();
    setTimeout(function(){
      window.scroll({top: 0,left: 0,behavior: 'smooth'});
      (document.querySelector('.first-focus') as any).focus();
    },1000);
  }

  addQuestion():void{
    const questionsArr:FormArray = this.qForm.controls.Questions as FormArray;
    questionsArr.push(this.fb.group({
      TenderId:new FormControl(this.tender.TenderId),
      QuesionnaireId: new FormControl(0),
      QuestionId: new FormControl(0),
      Index: new FormControl(this.qsList.length+1),
      RelatedSection : new FormControl('',[Validators.required,Validators.pattern("^([0-9א-תa-zA-Z \"_'\\\@\?!\.\(\)\:\,\/\\-])*$")]),
      QuestionDesc: new FormControl('',[Validators.required,Validators.pattern("^([0-9א-תa-zA-Z \"_'\\\@\?!\.\(\)\:\,\/\\-\r\n])*$")])
    }));
    this.qsList = questionsArr.controls;
    if(questionsArr.length>1)
      setTimeout(()=>(document.querySelectorAll('[formcontrolname="RelatedSection"]')[questionsArr.length-1] as any)?.focus(),100);
  }

  deleteQuestion(index:number):void{
    const questionsArr:FormArray = this.qForm.controls.Questions as FormArray;
    for(var i=questionsArr.length-1;i>index;i--)
      (questionsArr.at(i) as FormGroup).controls.Index.setValue((questionsArr.at(i-1) as FormGroup).controls.Index.value);
    questionsArr.removeAt(index);
    this.qsList = questionsArr.controls;
  }

  getIndex(i:number):string{
    return (this.qsList[i] as FormGroup).controls.Index.value.toString();
  }

  lockBtn:boolean = false;
  isSubmitted:boolean = false;
  onSubmit():void{
    this.isSubmitted = true;
    if(this.qForm.invalid){
      //console.log(document.querySelectorAll('[aria-describedby^="mat-error"]').length);
      (document.querySelectorAll('.mat-form-field.ng-invalid .mat-input-element')[0] as any).focus();
      /*setTimeout(()=>{
        this.updateFormAriaDescribedBy();
      },1000);*/
      return;
    }
    document.querySelectorAll('.ng-valid[aria-describedby]').forEach(x=>x.removeAttribute('aria-describedby'));
    this.recaptchaV3Service.execute('importantAction')
    .subscribe((token: any) => {
      this.qForm.controls.CaptchaToken.setValue(token);
      const sData = JSON.stringify(this.qForm.value);
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Strict-Transport-Security':'max-age=31536000; includeSubDomains'},
          body: sData,
          withCredentials:true
      };
      fetch(environment.serviceUrl+'/api/question', requestOptions)
        .then(response => response.json())
        .then(res =>{
          console.log(res);
          if(res.Success==true){
            alert('שאלותיך נשלחו בהצלחה');
            this.lockBtn = true;
            this.close();
          }
          else
            alert(res.Error);          
        })
        .catch(error => {
          console.error('There was an error!', error);
          alert('חלה תקלה, נא נסו מאוחר יותר.');
        });
    });
  }

  updateFormAriaDescribedBy():void{
    //console.log(document.querySelectorAll('[aria-describedby^="mat-error"]').length);
    const invalidCtrls:NodeListOf<Element> = document.querySelectorAll('.ng-invalid[formControlName]');
    invalidCtrls.forEach(x=>{
      this.setAriaDescribedBy(x);
    });
    document.querySelectorAll('.ng-valid[aria-describedby]').forEach(x=>x.removeAttribute('aria-describedby'));
  }

  updateAriaDescribeBy($event:any):void{
    if(!$event.srcElement || !$event.srcElement.classList.contains('ng-invalid')) return;

    setTimeout(() => {
      this.setAriaDescribedBy($event.srcElement);
    }, 100);
  }

  setAriaDescribedBy(errorCtrl:Element|null):void{
    if(errorCtrl){
      const errorDiv:Element|null = errorCtrl.parentElement!.querySelector('.mat-error');
      if(errorDiv && errorDiv.innerHTML){
        errorCtrl.setAttribute('aria-describedby',errorDiv.innerHTML);
      }
    }
  }

  onCancel():void{
    if(window.innerWidth<500){
      this.router.navigateByUrl('/tender/'+this.tender.TenderId,{state: {tender:this.tender}});
    }
    else {
      //this.location.back();
      this.router.navigate(['']);
      setTimeout(function(){
        (document.querySelector('h1') as any).focus();
      },1000);
    }
  }

  close():void{
    this.onClose.emit();
  }

  getError(ctrlName:string):string{
    if(this.qForm.controls[ctrlName].errors){
      if(this.qForm.controls[ctrlName].errors!.required)
        return 'שדה חובה';
      if(this.qForm.controls[ctrlName].errors!.email)
        return 'כתובת דואר אלקטרוני לא תקינה';
      if(this.qForm.controls[ctrlName].errors!.pattern)
        return ctrlName.indexOf('Phone')>-1? 'מספר טלפון לא תקין' :(ctrlName.endsWith('Fax')?'מספר פקס לא תקין' :'הטקסט כולל תווים חריגים');
    }
    return '';
  }

  getQError(ctrlName:string,i:number):string{
    if((this.qsList[i] as FormGroup).controls[ctrlName].errors){
      if((this.qsList[i] as FormGroup).controls[ctrlName].errors!.required)
        return 'שדה חובה';
      if((this.qsList[i] as FormGroup).controls[ctrlName].errors!.email)
        return 'כתובת דואר אלקטרוני לא תקינה';
      if((this.qsList[i] as FormGroup).controls[ctrlName].errors!.pattern)
        return ctrlName.indexOf('Phone')>-1? 'מספר טלפון לא תקין' :(ctrlName.endsWith('Fax')?'מספר פקס לא תקין' :'הטקסט כולל תווים חריגים');
    }
    return '';
  }
}
